import React from 'react';
import { fade, FormLabel, makeStyles } from '@material-ui/core';
import { colors } from '@lifesize/clients.mui-components';

interface SectionLabelProps {
  label: string;
}

const SectionLabel = (props: SectionLabelProps) => {
  const classes = useStyles();
  return (
    <FormLabel className={classes.formLabel} component="label">
      {props.label}
    </FormLabel>
  );
};

export default SectionLabel;

const useStyles = makeStyles(() => ({
  formLabel: {
    color: fade(colors.black, 0.87),
    fontWeight: 600,
    fontSize: '1.5rem'
  }
}));
